if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      connectedCallback() {
        this.variantButtons = Array.from(
          this.querySelectorAll('.cart-upsell__variant-button')
        );
        if (!this.variantButtons.length) return;

        this.onVariantClick = this.updateVariant.bind(this);
        this.variantButtons.forEach((button) => {
          button.addEventListener('click', this.onVariantClick);
        });
      }

      disconnectedCallback() {
        if (!this.variantButtons || !this.onVariantClick) return;
        this.variantButtons.forEach((button) => {
          button.removeEventListener('click', this.onVariantClick);
        });
      }

      updateVariant(event) {
        const selectedButton = event.currentTarget;
        if (!selectedButton || selectedButton.disabled) return;

        const variantInput = this.querySelector('#CartDrawerUpsell-VariantInput');
        const price = this.querySelector('.cart-upsell__price');
        const comparePrice = this.querySelector('.cart-upsell__compare-price');
        const savings = this.querySelector('.cart-upsell__savings');
        const savingsValue = this.querySelector('.cart-upsell__savings-value');
        const variantCurrent = this.querySelector(
          '.cart-upsell__variant-current'
        );
        const image = this.querySelector('img.cart-upsell__image');
        const addButton = this.querySelector('.cart-upsell__button');
        const buttonText = addButton?.querySelector('.button-text');
        const soldOutMessage = addButton?.querySelector('.sold-out-message');

        this.variantButtons.forEach((button) => {
          const isSelected = button === selectedButton;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        });

        if (variantInput) variantInput.value = selectedButton.dataset.variantId;
        if (variantCurrent) {
          variantCurrent.textContent = selectedButton.dataset.variantTitle || '';
        }
        if (price) price.textContent = selectedButton.dataset.price || '';

        if (comparePrice) {
          comparePrice.textContent = selectedButton.dataset.comparePrice || '';
          comparePrice.hidden = !selectedButton.dataset.comparePrice;
        }

        if (savings && savingsValue) {
          savingsValue.textContent = selectedButton.dataset.savings || '';
          savings.hidden = !selectedButton.dataset.savings;
        }

        if (
          image &&
          this.dataset.lockImage !== 'true' &&
          selectedButton.dataset.imageUrl
        ) {
          image.src = selectedButton.dataset.imageUrl;
        }

        if (addButton) {
          const isAvailable = selectedButton.dataset.available === 'true';
          addButton.disabled = !isAvailable;
          if (isAvailable) addButton.removeAttribute('aria-disabled');
          if (buttonText) buttonText.classList.remove('hidden');
          if (soldOutMessage) soldOutMessage.classList.add('hidden');
        }
      }
    }
  );
}

if (!window.cartDrawerCheckoutHandlerRegistered) {
  window.cartDrawerCheckoutHandlerRegistered = true;

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const checkoutButton = event.target.closest('#CartDrawer-Checkout');
      if (
        !checkoutButton ||
        checkoutButton.disabled ||
        checkoutButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      const formId = checkoutButton.getAttribute('form') || 'CartDrawer-Form';
      const cartForm = document.getElementById(formId);
      if (!cartForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      let checkoutInput = cartForm.querySelector(
        'input[data-cart-drawer-checkout]'
      );
      if (!checkoutInput) {
        checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = 'Checkout';
        checkoutInput.dataset.cartDrawerCheckout = 'true';
        cartForm.appendChild(checkoutInput);
      }

      checkoutButton.setAttribute('aria-disabled', 'true');
      HTMLFormElement.prototype.submit.call(cartForm);
    },
    true
  );
}
